import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';

const LANGS = [
  { code: 'en', label: 'EN' },
  { code: 'ru', label: 'RU' },
  { code: 'fi', label: 'FI' },
];

const LangSwitcher = () => {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2) || 'en';
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const currentLang = LANGS.find(l => l.code === current) || LANGS[0];
  const others = LANGS.filter(l => l.code !== current);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="lang-switcher" ref={ref}>
      <button
        className="lang-switcher__trigger"
        onClick={() => setOpen(prev => !prev)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {currentLang.label}
        <span className={`lang-switcher__arrow ${open ? 'lang-switcher__arrow--open' : ''}`}>▾</span>
      </button>

      {open && (
        <ul className="lang-switcher__dropdown" role="listbox">
          {others.map(lang => (
            <li key={lang.code}>
              <button
                className="lang-switcher__option"
                onClick={() => handleSelect(lang.code)}
                role="option"
              >
                {lang.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LangSwitcher;
